/**
 * Module that represents the global parameters value to specifc page type.
 *
 * Use getGlobalConfiguration and set the specifc page type.
 * Valid page types:
 *  - HomePage
 */
(function ga4Tracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const previousModule = global.NewHomeSource.Analytics.Ga4Configuration;
  let configurations = null;

  /**
  * @constructs NewHomeSource.Analytics.Ga4Configuration
  */
  function Ga4Configuration(globalValues) {
    configurations = {
      HomePage: {
        brandPartnerName: globalValues.brand_partner_name,
        pageType: globalValues.page_type,
        partnerId: globalValues.partner_id,
        partnerName: globalValues.partner_name,
        userMarketId: globalValues.userMarketId,
        userStatus: globalValues.userStatus,
        userZipCode: globalValues.userZipCode,
        user: globalValues.userId,
        brandPartnerNamePartnerName: globalValues.brandPartnerNamePartnerName,
        gaUserId: globalValues.googleAnalyticsUserId,
        time: globalValues.time,
        referCode: globalValues.referCode,
      },
      SearchResults: {
        brandPartnerName: globalValues.brand_partner_name,
        pageType: globalValues.page_type,
        partnerId: globalValues.partner_id,
        partnerName: globalValues.partner_name,
        userMarketId: globalValues.userMarketId,
        userStatus: globalValues.userStatus,
        userZipCode: globalValues.userZipCode,
        user: globalValues.userId,
        brandPartnerNamePartnerName: globalValues.brandPartnerNamePartnerName,
        gaUserId: globalValues.googleAnalyticsUserId,
        time: globalValues.time,
        referCode: globalValues.referCode,
        market_id: globalValues.marketId,
        market_name: globalValues.marketName,
        market_session: globalValues.marketSession,
        location: globalValues.location
      },
      Details: {
        amenities: globalValues.amenities,
        brand_id: globalValues.brand_id,
        brand_name: globalValues.brand_name,
        brandPartnerName: globalValues.brand_partner_name,
        brandPartnerNamePartnerName: globalValues.brandPartnerNamePartnerName,
        builder_corp: globalValues.builder_name,
        builder_division: globalValues.builder_division,
        builder_id: globalValues.builder_id,
        builder_name: globalValues.builder_name,
        community_id: globalValues.communityId,
        community_name: globalValues.community_name,
        community_status: globalValues.communityType,
        county: globalValues.county,
        gaUserId: globalValues.googleAnalyticsUserId,
        has_ifp: globalValues.hasIfp,
        has_isp: globalValues.hasIsp,
        home_price: globalValues.home_price,
        home_status: globalValues.home_type,
        is_limited_availability: globalValues.isLimitedAvailability,
        is_priced: globalValues.isPriced,
        is_spotlight: globalValues.wasMatchedAsSpotlightResult,
        location: globalValues.location,
        market_id: globalValues.marketId,
        market_name: globalValues.marketName,
        market_session: globalValues.marketSession,
        max_price: globalValues.community_high_price,
        min_price: globalValues.community_low_price,
        off_market: globalValues.offMarket,
        pageType: globalValues.page_type,
        partnerId: globalValues.partner_id,
        partnerName: globalValues.partner_name,
        plan_id: globalValues.plan_id,
        plan_name: globalValues.plan_name,
        price_reduction: globalValues.price_reduction,
        primary_image: globalValues.primary_image_url,
        referCode: globalValues.referCode,
        spec_id: globalValues.spec_id,
        srp_position: globalValues.resultPosition,
        time: globalValues.time,
        trustbuilder_reviews: globalValues.trustBuilderReviews,
        user: globalValues.userId,
        userMarketId: globalValues.userMarketId,
        userStatus: globalValues.userStatus,
        userZipCode: globalValues.userZipCode,
        zip_code: globalValues.zip
      },
      BuilderShowcase: {
        referCode: globalValues.referCode,
        pageType: globalValues.page_type,
        off_market: globalValues.offMarket,
        market_session: globalValues.marketSession,
        market_id: globalValues.marketId,
        partnerName: globalValues.partner_name,
        user: globalValues.userId,
        builder_name: globalValues.builder_name,
        brandPartnerNamePartnerName: globalValues.brandPartnerNamePartnerName,
        partnerId: globalValues.partner_id,
        gaUserId: globalValues.googleAnalyticsUserId,
        userStatus: globalValues.userStatus,
        time: globalValues.time,
        brand_id: globalValues.brand_id,
        brand_name: globalValues.brand_name,
        trustbuilder_reviews: globalValues.trustBuilderReviews,
        brandPartnerName: globalValues.brand_partner_name
      }
    };
  }

  Ga4Configuration.getGlobalConfiguration = function globalConfiguration(pageType) {
    const configurationObj = (pageType && configurations[pageType]) || configurations.HomePage;

    const params = {};
    Object.keys(configurationObj).forEach((key) => {
      params[key] = configurationObj[key];

      if (configurationObj[key] && typeof configurationObj[key].getValue === 'function') {
        configurationObj[key] = configurationObj[key].getValue(true);
        params[key] = configurationObj[key];
      }

      if (typeof configurationObj[key] === 'function') {
        params[key] = configurationObj[key]();
      }
    });
    return params;
  };

  /**
     * @public
     * noConflict: Returns control of NewHomeSource.Ga4Configuration to the previous script.
     */
  Ga4Configuration.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.Ga4Configuration = previousModule;
    return Ga4Configuration;
  };

  global.NewHomeSource.Analytics.Ga4Configuration = Ga4Configuration;

  return Ga4Configuration;
}(window));
